import {
  storageBoxApi,
  isPreviewableImage,
  isPreviewableVideo,
  isPreviewablePdf,
  isPreviewableOfficeDocument,
  getOfficeDocumentKind,
} from '../api/storageBoxApi';

export function isStorageBoxViewableMedia(item) {
  if (!item || item.type !== 'file') return false;
  return (
    isPreviewableImage(item.mimeType, item.name) ||
    isPreviewableVideo(item.mimeType, item.name) ||
    isPreviewablePdf(item.mimeType, item.name) ||
    isPreviewableOfficeDocument(item.mimeType, item.name)
  );
}

function storageBoxViewerItemType(item) {
  if (isPreviewableVideo(item.mimeType, item.name)) return 'video';
  if (isPreviewablePdf(item.mimeType, item.name)) return 'pdf';
  if (isPreviewableOfficeDocument(item.mimeType, item.name)) return 'office';
  return undefined;
}

export function buildStorageBoxMediaViewerItems(items, publicToken, lockPlayback = null) {
  if (!items?.length) return [];
  return items
    .filter((item) => isStorageBoxViewableMedia(item))
    .map((item) => {
      const type = storageBoxViewerItemType(item);
      if (item.isEncrypted && lockPlayback) {
        const url = lockPlayback.urls[item.itemId] || '';
        const lockSource = { item, lockSessionToken: lockPlayback.lockSessionToken };
        if (type === 'video') {
          return {
            itemId: item.itemId,
            url: '',
            alt: item.name,
            fileName: item.name,
            type,
            lockSource,
          };
        }
        if (!url) {
          return {
            itemId: item.itemId,
            url: '',
            alt: item.name,
            fileName: item.name,
            type,
            officeKind: getOfficeDocumentKind(item.mimeType, item.name) || undefined,
            lockSource,
          };
        }
        return {
          itemId: item.itemId,
          url,
          alt: item.name,
          fileName: item.name,
          type,
          officeKind: getOfficeDocumentKind(item.mimeType, item.name) || undefined,
        };
      }
      return {
        itemId: item.itemId,
        url: storageBoxApi.downloadUrl(item.itemId, { publicToken }),
        alt: item.name,
        fileName: item.name,
        type,
        officeKind: getOfficeDocumentKind(item.mimeType, item.name) || undefined,
      };
    });
}

export function indexOfMediaItem(viewerItems, itemId) {
  if (!itemId || !viewerItems?.length) return 0;
  const idx = viewerItems.findIndex((entry) => entry.itemId === itemId);
  return idx >= 0 ? idx : 0;
}
